



















































































































































import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { PrintAreaCustomization, PrintArea } from "@/models";
import CanvasManager from "@/helpers/CanvasManager";
import Controls from "@/components/Customizer/Controls.vue";
import TextOverlay from "@/components/Customizer/TextOverlay.vue";
import BackgroundOverlay from "@/components/Customizer/BackgroundOverlay.vue";
import EmojiOverlay from "@/components/Customizer/EmojiOverlay.vue";
import { TextConfiguration } from "@/models/types";
import { isMobile } from "@/helpers/mediaQueryHelper";
import Onboarding from "@/components/Customizer/Onboarding.vue";
import { bus } from "@/main";
import { previewBus } from "@/main";
import { scaleInputJson } from "@/helpers/customizerHelper";
import { fabric } from "fabric";
import { addToCart } from "@/services/woocommerceService";
import { easync } from "@/helpers/http";
import PinchZoom from "@/helpers/pinch-zoom-js";
import {
  customizationStore,
  httpStore,
  onboardingStore,
  currentUserStore,
} from "@/store/typed";
import BottomBar from "@/components/PrintAreaCustomization/BottomBar.vue";
import { CART_SLUG, MAX_FILE_SIZE_MB } from "@/constants";
import { showError, showSuccess } from "@/helpers/Toast";
import ClickOutside from "@/directives/ClickOutside";
import CloseModal from "@/components/Common/CloseModal.vue";
import TermsModal from "@/components/Common/TermsModal.vue";
import { STORE_URL, CONFIGURATOR_PAGE_SLUG, SHOP_PAGE_PATH } from "@/constants";
import { Tags } from "@/helpers/CanvasManager";


@Component({
  components: {
    BottomBar,
    Controls,
    EmojiOverlay,
    TextOverlay,
    Onboarding,
    CloseModal, TermsModal,
    BackgroundOverlay,
  },
  directives: {
    ClickOutside,
  },
})
export default class PrintAreaCustomizationEditor extends Vue {
  @Prop({ required: true }) readonly value!: PrintAreaCustomization;
  private dragging = false;
  private pinching = false;
  private canvasManager: CanvasManager = null;
  private printAreaCustomization: PrintAreaCustomization = this.value;
  private textOverlayVisible = false;
  private backgroundOverlayVisible = false;
  private emojiOverlayVisible = false;
  private rollbacking = false;
  private inDeleteZone = false;
  private showVerticalGuidline = false;
  private showHorizontalGuidline = false;
  private closeModalVisible = false;
  private lastOutputUploaded = null;

  @Ref() readonly textOverlay: any;
  @Ref() readonly backgroundOverlay: any;
  @Ref() readonly emojiOverlay: any;
  @Ref() readonly fileUploader!: any;
  @Ref() readonly trashLayer!: any;

  pz = null;

  get navigationLocked() {
    return customizationStore.navigationLocked;
  }

  get maskImageUrl() {
    return this.printArea.maskImage?.url || null;
  }

  async switchTo3D() {
    await this.uploadSvg();
    this.canvasManager.canvas.discardActiveObject();
    this.canvasManager.canvas.renderAll();
    this.$emit("preview", "3d");
  }

  //getters

  get canvas() {
    return this.canvasManager?.canvas || null;
  }

  get id() {
    return `canvas-${this.printAreaCustomization?.id}`;
  }

  closeOverlays() {
    if (this.textOverlayVisible) {
      this.textOverlay.done();
    }
    if (this.backgroundOverlayVisible) {
      this.backgroundOverlay.done();
    }
  }

  get deviceCanvasWidth() {
    return this?.printAreaCustomization?.deviceCanvasWidth || 0;
  }

  get deviceCanvasHeight() {
    return this?.printAreaCustomization?.deviceCanvasHeight || 0;
  }

  get canvasUpperLayerStyle() {
    return {
      width: (this.deviceCanvasWidth || 0) + "px",
      height: (this.deviceCanvasHeight || 0) + "px",
    };
  }

  get zoomEnabled() {
    return customizationStore.zoomEnabled;
  }

  get printArea(): PrintArea {
    return this.printAreaCustomization.printArea;
  }

  async destroyCustomization(){
    await customizationStore.destroyCustomization();
  }

  get overlaysVisible() {
    return (
      this.backgroundOverlayVisible ||
      this.textOverlayVisible ||
      this.emojiOverlayVisible
    );
  }

  get isMobile() {
    return isMobile((this as any).$mq);
  }

  get displayOnboarding() {
    return onboardingStore.onboarding;
  }

  get product() {
    return customizationStore.product;
  }

  get productCustomization() {
    return customizationStore.productCustomization;
  }

  get allItemsConfigured(): boolean {
    return customizationStore.allItemsConfigured;
  }

  @Watch("allItemsConfigured")
  onAllItemsConfiguredChanged(val: boolean) {
    if (val) {
      this.hideBottomBarTooltip();
    }
  }

  hideBottomBarTooltip() {
    this.$nextTick(() => {
      (this.$refs.bottomBar as any).hideItemNotCompletedTooltip();
    });
  }

  showFileTooLargeToast(): void {
    showError(this.$t("warnings.image_too_big").toString());
  }

  // flow

  async mounted() {
    this.openTermsModal();
    this.subscribeToUploadSvg();
    await this.initCanvasAndListeners();
    if (this.isMobile) {
      this.initCanvasPinchZoom();
    }
    this.checkIfZoomableByDefault();
  }


  openTermsModal(){
    if(!this.productCustomization.termsAccepted && this.resourceUpdateable){
      (this.$refs.termsModal as any).show(true);
    }
  }

  subscribeToUploadSvg() {
    bus.$on("uploadSvg", async (data) => {
      await this.uploadSvgAfterEvent(data);
    });
  }

  @Watch("value")
  onValueChanged(value: PrintAreaCustomization) {
    this.printAreaCustomization = value;
    this.initCanvasAndListeners();
  }

  async initCanvasAndListeners() {
    await this.$nextTick();
    this.printAreaCustomization.initDeviceDimensions();
    this.canvasManager = new CanvasManager(
      this.id,
      this.deviceCanvasWidth,
      this.deviceCanvasHeight
    );
    this.canvasManager.setIsMobile(this.isMobile);
    this.canvasManager.init(this.id, {
      complete: () => console.log("Canvas loaded! ✅"),
      error: () => console.log("Canvas could not be loaded 🛑"),
    });
    this.canvasManager.addCanvasChangedListener({
      updated: (o: any) => this.persistOutputLocally(),
      added: (o: any) => this.persistOutputLocally(),
      removed: (o: any) => this.persistOutputLocally(),
    });
    this.canvasManager.addOnTapListener((e: any) => {
      this.onTapHandler(e);
    });

    this.canvasManager.addOnDragListener((drag: boolean) => {
      this.dragging = drag;
      this.checkIfCanvasZoomable();
    });
    this.canvasManager.addOnPinchListener((pinch: boolean) => {
      this.pinching = pinch;
      this.checkIfCanvasZoomable();
    });

    this.canvasManager.addTrashCanListener({
      onTrash: (show: boolean, object: any) => (this.inDeleteZone = show),
    });
    if (this.isMobile) {
      this.canvasManager.addGuidelinesListener({
        horizontal: (show: boolean) => {
          this.showHorizontalGuidline = show;
        },
        vertical: (show: boolean) => {
          this.showVerticalGuidline = show;
        },
      });
    }
    this.addBeforeUnloadListener();
    await this.importCanvasJSON();
  }

  addBeforeUnloadListener(): void {
    window.addEventListener("beforeunload", this.onBeforeUnload, false);
  }

  async onBeforeUnload(e: any): Promise<void> {
    await this.uploadSvg();
  }

  removeBeforeUnloadListener(): void {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  }

  get resourceUpdateable() {
    return customizationStore.updateable;
  }

  async importCanvasJSON() {
    const pac = this.printAreaCustomization;

    if (!pac.scaled && pac.deviceParamsCalculated) {
      pac.output = scaleInputJson(pac.output, pac.deviceRatio);
      pac.scaled = true;
    }
    this.beforeJSONLoads();
    await this.canvasManager.importJSON(
      this.printAreaCustomization.output,
      !this.isMobile
    );
    await this.afterJSONLoaded();
  }

  async afterJSONLoaded() {
    await this.canvasManager.addWatermark(this.printArea);
    if (!this.printAreaCustomization.output) {
      this.canvasManager.canvas.backgroundColor =
        this.printAreaCustomization.printArea.defaultBackgroundColor;
    }
    this.lastOutputUploaded = JSON.stringify(
      this.printAreaCustomization.output
    );
    this.canvasManager.canvas.renderAll();
  }

  beforeJSONLoads() {
    this.canvasManager.canvas.backgroundColor =
      this.printAreaCustomization.printArea.defaultBackgroundColor;
  }

  // add stuff

  async addImage(event: any): Promise<void> {
    customizationStore.setNavigationLocked(true);
    const file = event.target.files[0];
    const reader = new FileReader();
    const fileSizeInMb = file.size / (1024 * 1024);
    if (fileSizeInMb > MAX_FILE_SIZE_MB) {
      this.showFileTooLargeToast();
      customizationStore.setNavigationLocked(false);
      return;
    }
    reader.onload = async (e: any) => {
      let data = e.target.result;
      const url = await customizationStore._uploadPicture(data);
      this.fileUploader.value = null;
      fabric.Image.fromURL(
        url,
        (img: any) => {
          this.canvasManager.createAndAddFabricImage(img, !this.isMobile);
          this.canvasManager.bringTextToFront();
          customizationStore.setNavigationLocked(false);
        },
        { crossOrigin: "anonymous" }
      );
    };
    reader.readAsDataURL(file);
  }

  async addEmoji(url: string): Promise<void> {
    if (!url) {
      return;
    }
    httpStore.register(Tags.LoadEmoji);
    httpStore.setLoading({ tag: Tags.LoadEmoji, loading: true });
    customizationStore.setNavigationLocked(true);
    fabric.Image.fromURL(
      url,
      (img: any) => {
        httpStore.setLoading({ tag: Tags.LoadEmoji, loading: false });
        this.canvasManager.createAndAddFabricImage(img, !this.isMobile);
        this.canvasManager.bringTextToFront();
        customizationStore.setNavigationLocked(false);
      },
      { crossOrigin: "anonymous" }
    );
  }

  // background

  onBackgroundCompleted(data: any) {
    this.onBackgroundChanged(data);
    this.backgroundOverlayVisible = false;
    this.subscribeToUploadSvg();
  }

  //zoom

  @Watch("zoomEnabled")
  onZoomEnabled(val: boolean) {
    if (val) {
      this.pz?.enable();
    } else {
      this.pz?.disable();
    }
  }

  checkIfZoomableByDefault(){
    customizationStore.setZoomEnabled(this.printArea.zoomByDefault)
  }

  checkIfCanvasZoomable() {
    if (this.dragging || this.pinching) {
      this.pz?.disable();
    } else if (this.zoomEnabled) {
      this.pz?.enable();
    }
  }

  initCanvasPinchZoom() {
    const el = document.getElementById("canvas_container");
    this.pz = new PinchZoom(el, {
      draggableUnzoomed: false,
      minZoom: 1,
      maxZoom: 6,
      use2d: true,
    });
    if (!this.zoomEnabled) {
      this.pz.disable();
    }
  }

  //emoji

  onEmojiChanged(data: any): void {
    // this.canvasManager.canvas.renderAll();
    this.addEmoji(data.url);
    this.persistOutputLocally();
  }

  onBackgroundChanged(data: any): void {
    this.canvasManager.canvas.backgroundColor = data.color;
    this.canvasManager.canvas.renderAll();
    this.persistOutputLocally();
  }

  onEmojiCompleted(data: any) {
    this.onEmojiChanged(data);
    this.emojiOverlayVisible = false;
    this.subscribeToUploadSvg();
  }

  // text

  onTextSaved(data: any): void {
    this.textOverlayVisible = false;

    if (data.id) {
      this.updateText(data);
    } else {
      this.addText(data);
    }
    this.subscribeToUploadSvg();
  }

  onTextEditCanceled(object) {
    object?.set({ selected: false, opacity: 1 });
    this.canvasManager.canvas.renderAll();
    this.textOverlayVisible = false;
  }

  addText(data: TextConfiguration) {
    if (!data.text) {
      return;
    }
    this.canvasManager.createAndAddFabricText(data, !this.isMobile);
  }

  updateText(payload: any) {
    let object: any = null;
    this.canvasManager.canvas.getObjects().forEach((o: any) => {
      if (o.id === payload.id) {
        object = o;
      }
    });
    if (!object) {
      return;
    }

    if (!payload.text) {
      this.canvasManager.canvas.remove(object);
    } else {
      object.set({ ...payload, opacity: 1 });
    }
    this.canvasManager.canvas.renderAll();
    this.canvasManager.canvas.fire("object:modified");
    this.canvasManager.removeAllEmptyTexts();
  }

  // overlays logic
  openTextOverlay(object: any | null) {
    customizationStore.updatedLastCustomizedAt();
    this.canvasManager.canvas.selection = false;
    this.canvasManager.canvas.discardActiveObject();
    if (object) {
      object?.set({ selected: false, opacity: 0 });
    }
    this.canvasManager.canvas.renderAll();
    this.textOverlayVisible = true;
    (this.textOverlay as any).show(this.canvasManager.canvas, object);
  }

  openBackgroundOverlay() {
    customizationStore.updatedLastCustomizedAt();
    this.backgroundOverlayVisible = true;
    this.backgroundOverlay.show(this.canvasManager.canvas.backgroundColor);
  }

  openEmojiOverlay() {
    customizationStore.updatedLastCustomizedAt();
    this.canvasManager.canvas.selection = false;
    this.canvasManager.canvas.discardActiveObject();
    this.canvasManager.canvas.renderAll();
    this.emojiOverlayVisible = true;
    (this.emojiOverlay as any).show();
  }

  triggerFileUpload() {
    customizationStore.updatedLastCustomizedAt();
    this.fileUploader.click();
  }

  onTapHandler(e: any) {
    const object = this.canvasManager.canvas.getActiveObject();
    if (object?.type == "image") {
      this.canvasManager.canvas.bringToFront(object);
      this.canvasManager.bringTextToFront();
    }

    if (!object || object.type != "text") {
      return;
    }
    this.openTextOverlay(object);
  }

  //Controls

  onEditorClick(event: any) {
    if (this.isMobile) {
      return;
    }
    const canvas = document.getElementById(this.id);
    if (!canvas) {
      return;
    }
    const rect = canvas.getBoundingClientRect();

    if (this.textOverlayVisible) {
      const textEditor = document.getElementsByClassName("text-editor")[0];
      if (!textEditor) {
        return;
      }
      const textEditorRect = textEditor.getBoundingClientRect();

      if (
        !this.eventContains(rect, event) &&
        this.eventContains(textEditorRect, event) &&
        event.srcElement.localName != "textarea" &&
        event.srcElement.className != "vc-saturation"
      ) {
        this.textOverlay.done();
      }
    }

    if (this.backgroundOverlayVisible) {
      const backgroundEditor = document.getElementsByClassName("spacing")[0];
      const backgroundEditorRect = backgroundEditor.getBoundingClientRect();

      if (
        !this.eventContains(rect, event) &&
        this.eventContains(backgroundEditorRect, event) &&
        event.srcElement.className != "vc-saturation"
      ) {
        this.backgroundOverlay.done();
      }
    }
  }

  eventContains(rect, event): boolean {
    let x = event.clientX;
    const dpr = 1;

    if (x < rect.left * dpr || x >= rect.right * dpr) {
      return false;
    }
    let y = event.clientY;
    if (y < rect.top * dpr || y >= rect.bottom * dpr) {
      return false;
    }
    return true;
  }

  //This helps maintaining the aspect ratio in the objects control
  @Watch("deviceCanvasWidth")
  async onCanvasWidthChanged() {
    await this.$nextTick();
    this.canvasManager.canvas.setWidth(this.deviceCanvasWidth);
  }

  //This helps maintaining the aspect ratio in the objects control
  @Watch("deviceCanvasHeight")
  async onCanvasHeightChanged() {
    await this.$nextTick();
    this.canvasManager.canvas.setHeight(this.deviceCanvasHeight);
  }

  //rollback logic

  async rollback() {
    if (this.rollbacking) {
      return;
    }
    this.rollbacking = true;
    await customizationStore.rollbackOutput();
    this.$nextTick(async () => {
      await this.canvasManager.importJSON(
        this.printAreaCustomization.output,
        !this.isMobile
      );
      this.rollbacking = false;
    });
  }

  // update logic
  persistOutputLocally() {
    previewBus.$emit(
      "preview" + this.printAreaCustomization.id,
      this.canvasManager.toDataURL()
    );
    if (this.rollbacking) {
      return;
    }
    customizationStore._updatePrintAreaCustomizationOutput(
      this.canvasManager.toJSON()
    );
  }

  async uploadSvg() {
    const jsonOutput = this.canvasManager.toJSON();
    if (JSON.stringify(jsonOutput) != this.lastOutputUploaded) {
      await customizationStore._uploadOutputSvgAsync({
        printAreaCustomization: this.printAreaCustomization,
        svg: this.canvasManager.toSVG(),
        output: this.canvasManager.toJSON(),
      });
      bus.$emit("uploadedSvg" + this.printAreaCustomization.id, true);
    } else {
      bus.$emit("uploadedSvg" + this.printAreaCustomization.id, true);
    }
    this.lastOutputUploaded = JSON.stringify(jsonOutput);
  }

  // SHARE

  async share() {
    await this.uploadSvg();
    const url = `${STORE_URL}/${CONFIGURATOR_PAGE_SLUG}?productId=${this.product.externalId}&productCustomizationId=${this.productCustomization.uuid}&shared=true`;
    if (navigator.share) {
      navigator
        .share({
          title: "ilmyo",
          text: this.$t("sharing.title").toString(),
          url: url,
        })
        .then(() => showSuccess(this.$t("sharing.success").toString()));
    } else {
      navigator.clipboard.writeText(url);
      showSuccess(this.$t("sharing.clipboard_success").toString());
    }
  }

  get editMode() {
    return customizationStore.editMode;
  }

  //ADD TO CART

  async addToCart() {
    await this.uploadSvg();
    const [data, error] = await easync(
      addToCart(this.product.externalId, 1, this.productCustomization?.uuid)
    );
    if (data) {
      this.goToCartPage();
    } else {
      console.error("Could not add to the cart", error);
    }
  }

  async goToCart() {
    await this.uploadSvg();
    this.goToCartPage();
  }

  async goToCartPage() {
    const lang = currentUserStore.lang;
    localStorage.removeItem("ilmyo_customizer");
    window.location.assign(`${STORE_URL}/${lang}/${CART_SLUG}`);
  }

  async beforeDestroy() {
    this.removeBeforeUnloadListener();
    await this.uploadSvg();
  }

  async uploadSvgAfterEvent(id: string) {
    const jsonOutput = this.canvasManager.toJSON();
    if (JSON.stringify(jsonOutput) != this.lastOutputUploaded) {
      await customizationStore._uploadOutputSvgAsync({
        printAreaCustomization: this.printAreaCustomization,
        svg: this.canvasManager.toSVG(),
        output: this.canvasManager.toJSON(),
      });
      bus.$emit("uploadedSvg" + id, true);
    } else {
      bus.$emit("uploadedSvg" + id, true);
    }
    this.lastOutputUploaded = JSON.stringify(jsonOutput);
  }

  //BACK

  async onBack() {
    this.closeModalVisible = true;
    const confirm = await (this.$refs.closeModal as any).dialog(
      customizationStore.editMode
        ? this.$t("warnings.back_when_product_in_cart")
        : this.$t("warnings.back_when_product_is_new")
    );
    this.closeModalVisible = false;
    if (!confirm) {
      localStorage.removeItem("ilmyo_customizer");
      const referrer = currentUserStore.referrer;
      if (this.editMode) {
        const lang = currentUserStore.lang;
        window.location.assign(`${STORE_URL}/${lang}/${CART_SLUG}`);
      } else {
        // await this.destroyCustomization();
        window.location.assign(referrer || `${STORE_URL}/${SHOP_PAGE_PATH}`);
      }
    }
  }
}
